import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=736d1a52&scoped=true&lang=pug"
import script from "./Progress.vue?vue&type=script&lang=ts"
export * from "./Progress.vue?vue&type=script&lang=ts"
import style0 from "./Progress.vue?vue&type=style&index=0&id=736d1a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d1a52",
  null
  
)

export default component.exports